import { cacheService } from '../services/cacheService';
import { globalStore } from '../global.store';
import { authorizationStore } from '../modules/authorization/authorization.store';
import { apiServiceV2 } from '../services/apiService';

export const useAuth = (searchParams: any) => {
  const authRequest = async (request: Function, req: any) => {
    try {
      const response = await request(req);
      cacheService.clear();
      const { accessToken } = response?.data;
      cacheService.set('auth_token', `${accessToken}`);
      searchParams.delete('auth');
      globalStore.setIsLogin(true);
      authorizationStore.setClearSearchParams(true);
      await globalStore.projectConfiguration();
    } catch (e: any) {
      console.warn('ERROR: ', e.message);
    }
  };

  const setGoogleLogin = async (res: any) => {
    await authRequest(responseGoogle, res);
  };

  const setAppleLogin = async (res: any) => {
    await authRequest(responseApple, res);
  };

  const responseGoogle = (response: any) =>
    apiServiceV2.setSocialLoginToken({
      jwt: response.credential,
      provider: 'google',
    });
  const responseApple = (response: any) =>
    apiServiceV2.setSocialLoginToken({
      jwt: response.authorization.id_token,
      provider: 'apple',
    });

  return {
    setGoogleLogin: setGoogleLogin,
    setAppleLogin: setAppleLogin,
  };
};
